/* eslint-disable react/prop-types */
import React, {
  useState, useEffect,
  useRef,
} from 'react';
import {
  Row,
  Tabs,
  Form,
  Col,
  Input,
  Spin,
  Card,
  // DatePicker,
  message,
  Button,
} from 'antd';
import {
  DeleteOutlined,
  EnvironmentOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import { onError } from 'utils/handlers';
import Select from 'components/Select';
// import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import NumericInput from 'components/NumericInput';
import { InputSearchPro } from 'components/InputSearch';
import { getContribuyenteCaja, getContribuyente } from 'api/empresas/contribuyentes';
import {
  deleteExpedienteDeModulo,
  getExpedienteDeModulo,
  getExpedientesDeModulos,
  patchExpedienteDeModulo,
  postExpedienteDeModulo,
} from 'api/empresas/modulos';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { getZonasDeModulos } from 'api/empresas/zonasDeModulo';
import { getMercadosDeModulos } from 'api/empresas/mercadosDeModulos';
import GirosDeModulos, { permissionConfig as permissionConfigGiros } from 'components/GirosDeModulos';
import { getGirosDeModulos } from 'api/empresas/girosDeModulos';
import { getTiposDeGirosModulos } from 'api/empresas/tiposDeGirosDeModulos';

export const permissionConfig = {
  permissionModel: 'expedientemodulodemercado',
  tabsModels: [permissionConfigGiros],
};

const { TabPane } = Tabs;
const baseURI = 'empresas/expediente-modulos-de-mercados';

const ExpedienteDeModulos = ({ permission }) => {
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [zonasDeModulo, setZonasDeModulo] = useState([]);
  const [mercadosDeModulos, setMercadosDeModulos] = useState([]);
  const searchRef = useRef();
  const [girosDeModulos, setGirosDeModulos] = useState([]);
  const [tipoDeGiros, setTipoDeGiros] = useState([]);
  const [params, setParams] = useState({});

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getExpedientesDeModulos({
      ...q,
      page,
      ...params,
    });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [_zonas, _mercados, _girosModulos, _tipos] = await Promise.all([
        getZonasDeModulos(),
        getMercadosDeModulos(),
        getGirosDeModulos(),
        getTiposDeGirosModulos(),
      ]);
      if (mounted) {
        setZonasDeModulo(_zonas);
        setMercadosDeModulos(_mercados);
        setGirosDeModulos(_girosModulos);
        setTipoDeGiros(_tipos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
  };

  const fetchContribuyente = async (id) => {
    if (!id) return;
    setLoading(true);
    const _contribuyente = await getContribuyente(id?.id || id);
    if (!_contribuyente) {
      message.info('No se encontró al contribuyente');
      setContribuyenteFound([]);
      setLoading(false);
      return;
    }
    setContribuyenteFound([_contribuyente]);
    setTimeout(() => {
      form.setFieldsValue({
        contribuyente: _contribuyente?.id,
        nombre_completo: _contribuyente?.nombre_completo,
      }, 100);
    });
    setLoading(false);
  };

  const onClickEdit = async (ExpedienteDeComercioInformalId) => {
    const key = selectedRowKeys[0] || ExpedienteDeComercioInformalId;
    const match = await getExpedienteDeModulo(key);
    if (match) {
      await fetchContribuyente(match?.contribuyente?.id ?? match?.contribuyente);
    }
    form.setFieldsValue(match);
    setVisible(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const _data = await (key ? patchExpedienteDeModulo(key, values)
        : postExpedienteDeModulo(values));
      if (_data) {
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
          }
          await onClickEdit(_data.id);
        } else {
          onCancel();
        }
        setLoading(false);
        return _data;
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading, [form], setCurrentTabKey);
      return false;
    }
  };
  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteExpedienteDeModulo(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
      }
    }
    setLoading(false);
  };

  const columns = [
    {
      titleText: 'Objeto Cuenta',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Propietario',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      render: (val) => (val?.nombre_completo),
      width: 200,
    },

    {
      titleText: 'Local',
      dataIndex: 'numero_de_puesto',
      key: 'numero_de_puesto',
      width: 200,
    },
    {
      titleText: 'Cantidad de Locales',
      dataIndex: 'numero_de_locales',
      key: 'numero_de_locales',
      width: 200,
    },
    {
      titleText: 'Superficie',
      dataIndex: 'superficie',
      key: 'superficie',
      width: 200,
    },
    {
      titleText: 'Giros',
      dataIndex: 'superficie',
      key: 'superficie',
      width: 200,
      render: (_, val) => {
        // eslint-disable-next-line max-len
        const [ids] = girosDeModulos.filter((e) => e.expediente_modulo === val?.id).map((e) => (e.giro_de_modulos));
        const _giros = tipoDeGiros.filter((e) => e.id === ids);
        return _giros?.map((e) => ` ${e.descripcion}`).toString();
      },
    },
    {
      titleText: 'Zona',
      key: 'zona_de_modulo',
      dataIndex: 'zona_de_modulo',
      width: 200,
      catalog: {
        cat: zonasDeModulo,
        use: true,
      },
    },
  ];

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q_contribuyente: q } = form.getFieldsValue();
      if (!q) {
        message.info('Ingrese algún dato para buscar al Contribuyente.');
        return;
      }
      const contribuyentes = await getContribuyenteCaja({ rfc: q });

      if (!contribuyentes?.results?.length) {
        message.info('No se encontró al Contribuyente.');
        return;
      }

      const [selected] = contribuyentes.results;
      form.setFieldsValue({
        contribuyente: selected.id,
        nombre_completo: selected.nombre_completo,
      });
      setContribuyenteFound([selected]);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const resetAndValidate = () => {
    setContribuyenteFound([]);
    form.resetFields(['q']);
    form.validateFields(['q']);
  };

  const handleSearchData = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const searchParams = formSearch.getFieldsValue();
      const keys = Object.keys(searchParams);
      const validProps = keys.filter((prop) => searchParams[prop]);
      setParams(searchParams);
      if (!validProps?.length) {
        message.warn('Debe ingresar al menos un campo.');
        return;
      }

      const _data = await getExpedientesDeModulos(searchParams);
      setData(_data);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = () => {
    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }
    searchRef.current = setTimeout(handleSearchData, 500);
  };

  const wipe = () => {
    formSearch.resetFields();
    setData({ results: [] });
    setParams({});
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible
          ? (
            <>
              <Form
                layout="vertical"
                form={formSearch}
                scrollToFirstError
                onFinish={() => debouncedSearch()}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="clave"
                      label="Objeto Cuenta"
                      hasFeedback
                      allowClear
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="contribuyente__nombre_completo"
                      label="Contribuyente (usar nombre completo)"
                      hasFeedback
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="zona_de_modulo"
                      label="Zona de Modulos"
                      hasFeedback
                    >
                      <Select dataSource={zonasDeModulo} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="numero_de_puesto"
                      label="Local"
                      hasFeedback
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={24} lg={8}>
                    <Button
                      htmlType="submit"
                      block
                      style={{ marginTop: 21 }}
                      icon={<SearchOutlined />}
                    >
                      Buscar
                    </Button>
                  </Col>
                  <Col xs={24} md={24} lg={8}>
                    <Button
                      onClick={wipe}
                      block
                      style={{ marginTop: 21 }}
                      icon={<DeleteOutlined />}
                    >
                      Limpiar Busqueda
                    </Button>
                  </Col>
                </Row>
              </Form>
              <Table
                cols={columns}
                mobileColumns={[columns[0]]}
                data={data?.results}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                controls={{
                  onClickAdd,
                  onClickEdit,
                  onClickDelete,
                }}
                rowKey="id"
                baseURI={baseURI}
                permission={permission}
                pagination={false}
                paginationCallback={fetchData}
                count={data.count}
                currentPage={currentPage}
              />
            </>
          ) : (
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Módulo`}
              extra={(
                <FormSubmitControls
                  onFinish={onFinish}
                  onCancel={onCancel}
                  allowSaveAndContinue
                  onCancelText="Cancelar"
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Tabs
                onChange={setCurrentTabKey}
                activeKey={currentTabKey}
              >
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      Información General
                    </span>
                  )}
                  key="general"
                  forceRender
                >
                  <Form
                    name="general"
                    layout="vertical"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>

                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave"
                          label="Objeto Cuenta"
                          hasFeedback
                          required
                        >
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="mercado_de_modulo"
                          label="Mercado"
                        >
                          <Select dataSource={mercadosDeModulos} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="zona_de_modulo"
                          label="Zona"
                        >
                          <Select dataSource={zonasDeModulo} />
                        </Form.Item>
                      </Col>
                      <InputSearchPro
                        label="RFC de Contribuyente"
                        name="q_contribuyente"
                        onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => searchContribuyente(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidate();
                            }
                          },
                        }}
                        resultProps={{
                          label: 'Contribuyente',
                          name: 'contribuyente',
                          dataSource: contribuyenteFound,
                          labelProp: 'nombre_completo',
                          onClear: resetAndValidate,
                          breakPoints: {
                            xs: 24,
                            sm: 24,
                            md: 8,
                          },
                        }}
                      />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_puesto"
                          label="Número de puesto"
                          hasFeedback
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_locales"
                          label="Número de locales"
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="metros_de_largo"
                          label="Largo"
                          decimal
                          commas
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="metros_de_ancho"
                          label="Ancho"
                          decimal
                          commas
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="superficie"
                          label="Superficie en m2"
                          decimal
                          commas
                        />
                      </Col>
                      <Col xs={24} sm={24} md={16}>
                        <Form.Item
                          name="observaciones"
                          label="Observaciones"
                          hasFeedback
                        >
                          <Input.TextArea autoSize={{ minRows: 3, maxRows: 3 }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <EnvironmentOutlined />
                      Giros
                    </span>
                  )}
                  key="giros"
                  forceRender={selectedRowKeys.length}
                  disabled={!selectedRowKeys.length}
                >
                  <GirosDeModulos
                    permission={permission.tabs.girocomercial}
                    expediente_modulo={selectedRowKeys[0]}
                  />
                </TabPane>
              </Tabs>
            </Card>
          )}
      </Spin>
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadrones}
        setVisible={setVisibleBusquedaPadrones}
        callback={(contribuyente) => fetchContribuyente(contribuyente?.id || contribuyente)}
        tipoDePadron={15}
        allowAdd={false}
      />
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleAlert(false)}
        visible={visibleAlert}
        content="Modulo seleccionado"
        loading={loading}
      />
    </Row>
  );
};

export default ExpedienteDeModulos;
